import request from "@/api";

export function listOrderIdentifier(data) {
    return request({
        url: '/api/order/getOrderIdentifierList',
        method: 'get',
        params: data
    })
}

export function listOrderIdentifierCache(data) {
    return request({
        url: '/api/order/getOrderIdentifierCacheList',
        method: 'get',
        params: data
    })
}

export function getOrderIdentifierInfo(data) {
    return request({
        url: '/api/order/getOrderIdentifierInfo',
        method: 'get',
        params: data
    })
}

export function saveOrderIdentifier(data) {
    return request({
        url: '/api/order/saveOrderIdentifier',
        method: 'post',
        data: data
    })
}

export function deleteOrderIdentifier(data) {
    return request({
        url: '/api/order/deleteOrderIdentifier',
        method: 'post',
        data: data
    })
}
